import { render, staticRenderFns } from "./SyndicatedDeals.vue?vue&type=template&id=7c2c85de&scoped=true&"
import script from "./SyndicatedDeals.vue?vue&type=script&lang=js&"
export * from "./SyndicatedDeals.vue?vue&type=script&lang=js&"
import style0 from "./SyndicatedDeals.vue?vue&type=style&index=0&id=7c2c85de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2c85de",
  null
  
)

export default component.exports